import { useState } from "react";
import {
  signInWithEmailAndPassword,
  sendPasswordResetEmail
} from "firebase/auth";

import { auth, database } from "../services/firebase";
import { ref, get } from "firebase/database";
import { useNavigate, Link } from "react-router-dom";

export default function Login() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const login = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await signInWithEmailAndPassword(auth, email, password);
      const uid = res.user.uid;

      const snap = await get(ref(database, `subscriptions/${uid}`));

      if (snap.exists()) {
        const data = snap.val();
        const expiry = new Date(data.expiryTimestamp);

        if (data.premium && expiry > new Date()) {
          alert("✅ Premium User Login");
          navigate("/premium-current-affairs");
          return;
        }
      }

      alert("✅ Login Successful");
      navigate("/");
    } catch (err) {
      alert(err.message);
    }

    setLoading(false);
  };

  const reset = async () => {
    if (!email) return alert("Enter Email");
    await sendPasswordResetEmail(auth, email);
    alert("Reset link sent");
  };

  return (
    <div
      className="premium-auth-wrapper"
      style={{
        minHeight: "100vh",
        background:
          "radial-gradient(circle at top left, rgba(56,189,248,0.10), transparent 24%), radial-gradient(circle at top right, rgba(34,197,94,0.10), transparent 26%), linear-gradient(135deg, #020617, #0f172a, #111827)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px"
      }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-md-8 col-lg-5">
            <div
              style={{
                borderRadius: "28px",
                padding: "34px 28px",
                background: "rgba(255,255,255,0.05)",
                border: "1px solid rgba(255,255,255,0.10)",
                backdropFilter: "blur(20px)",
                boxShadow: "0 20px 60px rgba(0,0,0,0.35)"
              }}
            >
              <div className="text-center mb-4">
                <div
                  style={{
                    display: "inline-block",
                    padding: "8px 18px",
                    borderRadius: "999px",
                    background: "rgba(56,189,248,0.12)",
                    border: "1px solid rgba(56,189,248,0.18)",
                    color: "#38bdf8",
                    fontWeight: 800,
                    fontSize: "12px",
                    letterSpacing: "1px"
                  }}
                >
                  UPSC PREMIUM ACCESS
                </div>

                <h2
                  className="fw-bold mt-4 mb-2"
                  style={{
                    color: "#ffffff",
                    fontSize: "2rem"
                  }}
                >
                  Welcome Back
                </h2>

                <p style={{ color: "#94a3b8", marginBottom: 0 }}>
                  Login to continue your UPSC preparation journey.
                </p>
              </div>

              <form onSubmit={login}>
                <input
                  type="email"
                  className="form-control mb-3"
                  placeholder="Enter your email"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />

                <div className="input-group mb-3">
                  <input
                    type={show ? "text" : "password"}
                    className="form-control"
                    placeholder="Enter your password"
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />

                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => setShow(!show)}
                  >
                    {show ? "🙈" : "👁"}
                  </button>
                </div>

                <button className="btn btn-success w-100 py-3 fw-bold rounded-4">
                  {loading ? "Please wait..." : "Login Now"}
                </button>

                <p
                  className="mt-3 mb-2 text-center"
                  style={{ cursor: "pointer", color: "#38bdf8" }}
                  onClick={reset}
                >
                  Forgot Password?
                </p>

                <p className="text-center mt-3 mb-0">
                  Don&apos;t have account?{" "}
                  <Link to="/register">Create Account</Link>
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}